import { styled, Divider } from '@mui/material'
import { Editor } from '@tiptap/react'
import {
  BlockquoteButton,
  BoldButton,
  CodeBlockButton,
  CodeButton,
  ItalicButton,
  OrderedListButton,
  StrikeButton,
  UnorderedListButton,
} from '../../../../components/toolbars/RichTextToolbar/StyleButton'

interface EditorToolbarProps {
  editor: Editor
}

export const EditorToolbar = ({ editor }: EditorToolbarProps) => {
  return (
    <ToolbarContainer>
      {/* テキストスタイル */}
      <StyledBoldButton editor={editor} disabled={false} highlightItems={[]} />
      <StyledItalicButton
        editor={editor}
        disabled={false}
        highlightItems={[]}
      />
      <StyledStrikeButton
        editor={editor}
        disabled={false}
        highlightItems={[]}
      />
      <StyledDivider orientation="vertical" variant="middle" flexItem={true} />

      {/* コード */}
      <StyledCodeButton editor={editor} disabled={false} highlightItems={[]} />
      <StyledCodeBlockButton
        editor={editor}
        disabled={false}
        highlightItems={[]}
      />
      <StyledDivider orientation="vertical" variant="middle" flexItem={true} />

      {/* 引用とリスト */}
      <StyledBlockquoteButton
        editor={editor}
        disabled={false}
        highlightItems={[]}
      />
      <StyledUnorderedListButton
        editor={editor}
        disabled={false}
        highlightItems={[]}
      />
      <StyledOrderedListButton
        editor={editor}
        disabled={false}
        highlightItems={[]}
      />
      <StyledDivider orientation="vertical" variant="middle" flexItem={true} />
    </ToolbarContainer>
  )
}

const ToolbarContainer = styled('div')({
  display: 'flex',
  gap: '2px',
  padding: '2px 4px',
  overflow: 'hidden',
  alignItems: 'center',
})

const StyledDivider = styled(Divider)({
  margin: 3,
})

const StyledBlockquoteButton = styled(BlockquoteButton)({ margin: 3 })
const StyledBoldButton = styled(BoldButton)({ margin: 3 })
const StyledCodeBlockButton = styled(CodeBlockButton)({ margin: 3 })
const StyledCodeButton = styled(CodeButton)({ margin: 3 })
const StyledItalicButton = styled(ItalicButton)({ margin: 3 })
const StyledOrderedListButton = styled(OrderedListButton)({ margin: 3 })
const StyledStrikeButton = styled(StrikeButton)({ margin: 3 })
const StyledUnorderedListButton = styled(UnorderedListButton)({ margin: 3 })
